import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'share-login',
    component: () => import('@/views/login.vue'),
  },
  {
    path: '/login/:scode',
    name: 'share-login-code',
    component: () => import('@/views/login.vue'),
  },
  {
    path: '/login/:scode/:type',
    name: 'share-login-code-type',
    component: () => import('@/views/login.vue'),
  },
  {
    path: '/resume/:scode',
    name: 'share-resume',
    component: () => import('@/views/resume/entry.vue'),
  },
  {
    path: '/index',
    redirect: '/login',
  },
  {
    path: '/index/:scode',
    redirect: to => `/resume/${encodeURIComponent(to.params.scode || '')}`,
  },
  {
    path: '/pages/login/login',
    redirect: to => {
      const scode = to.query.scode || ''
      const type = to.query.type || ''
      return {
        path: scode ? `/login/${encodeURIComponent(scode)}${type ? `/${encodeURIComponent(type)}` : ''}` : '/login',
        query: {},
      }
    },
  },
  {
    path: '/pages/login/login/:scode',
    redirect: to => ({
      path: `/login/${encodeURIComponent(to.params.scode || '')}`,
      query: {},
    }),
  },
  {
    path: '/pages/login/login/:scode/:type',
    redirect: to => ({
      path: `/login/${encodeURIComponent(to.params.scode || '')}/${encodeURIComponent(to.params.type || '')}`,
      query: {},
    }),
  },
  {
    path: '/pages/index/index',
    redirect: to => {
      const scode = to.query.scode || ''
      return {
        path: scode ? `/resume/${encodeURIComponent(scode)}` : '/login',
        query: {},
      }
    },
  },
  {
    path: '/pages/index/index/:scode',
    redirect: to => ({
      path: `/resume/${encodeURIComponent(to.params.scode || '')}`,
      query: {},
    }),
  },
  {
    path: '/404',
    name: 'not-found',
    component: () => import('@/views/noFound.vue'),
  },
  {
    path: '*',
    redirect: '/404',
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
